import { ModelDoc, PostDdlDocumentModel } from './docs_model'
import langEnum from '../../../../enums/langEnum'
import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum, types } from '../../../../enums/fetchFactoryEnum'
import { saveInteractions } from '../../../gtm/utils/gtmCallback'

export const convertDocumentList = (list: ModelDoc[]) =>
    list.map((item: ModelDoc) => convertDocumentItem(item))

export const convertDocumentItem = (item: ModelDoc) => (
    {
        id: item.id,
        type_document: item.type_document,
        titre_object: item.titre_object,
        no_bail: item.no_bail,
        dwstoredatetime: new Date(item.dwstoredatetime),
        renommage_fr: item.renommage_fr,
        renommage_en: item.renommage_en,
        no_facture_client: item.no_facture_client
    }
)

export const convertTypeList = (list: ModelDoc[]) =>
    list.map((item: ModelDoc) => convertTypeItem(item))

export const convertTypeItem = (item: ModelDoc) => (
    {
        type_document: item.type_document,
        renommage_fr: item.renommage_fr,
        renommage_en: item.renommage_en
    }
)

//Fetch for pdf to ddl
export const downloadPDF = (doc: ModelDoc, intl_locale: string, setLoadingDdl: (value: (((prevState: boolean) => boolean) | boolean)) => void) => {
    setLoadingDdl(true)
    const date: string = ` - ${doc.dwstoredatetime.toISOString().split('T')[0]}.pdf`
    let filename: string = intl_locale === langEnum.fr ? `${doc.renommage_fr}${date}` : `${doc.renommage_en}${date}`
    filename = filename.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    filename = filename.replace(/[^\x20-\x7E]+/g, '')
    const dwdocid: PostDdlDocumentModel = {
        id: doc.id,
        filename: filename
    }
    fetchFactory(
        `/api/ec_${process.env.REACT_APP_TARGET}/contrat/telechargeDocument`,
        {
            body: JSON.stringify(dwdocid),
            method: configEnum.post
        },
        types.blob
    )
        .then(
            (blob: any) => {
                saveInteractions(
                    {
                        category: 'Votre compte',
                        action: 'Téléchargement de documents',
                        label: filename
                    }
                )

                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = filename
                a.click()
            }
        )
        .finally(
            () => {
                setLoadingDdl(false)
            }
        )
}